/**
 * Do not edit directly, this file was auto-generated.
 */

export const RadiusNone = "0px";
export const RadiusSmall = "4px";
export const RadiusMedium = "8px";
export const RadiusLarge = "12px";
export const RadiusXlarge = "24px";
export const RadiusFull = "999px";
export const RadiusTopSmall = "4px 4px 0px 0px";
export const RadiusTopMedium = "8px 8px 0px 0px";
export const RadiusTopLarge = "12px 12px 0px 0px";
